// events/authEvents.ts
class AuthEvents {
  private listeners: (() => void)[] = [];

  onUnauthorized(callback: () => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((cb) => cb !== callback);
    };
  }

  emitUnauthorized() {
    this.listeners.forEach((callback) => callback());
  }
}

export const authEvents = new AuthEvents();
